import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const ImageModalActionsNextIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        viewBox="0 0 20 20"
        className="Icon image-modal-actions-next"
        {...props}
    >
        <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.67}
            d="M4.167 10h11.666M10 15.833 15.833 10 10 4.167"
        />
    </svg>
);
const Memo = memo(ImageModalActionsNextIcon);
export default Memo;
